export enum UserAccessPermissionsEnum {
  SUPPORT_TOOL_ACCESS = 'SUPPORT_TOOL_ACCESS',
  SUPPORT_TOOL_EDIT_PERMISSIONS = 'SUPPORT_TOOL_EDIT_PERMISSIONS',
  SUPPORT_TOOL_CREATE_ADMIN = 'SUPPORT_TOOL_CREATE_ADMIN',
  DTX_PHI_DATA_ACCESS_WRITE = 'DTX_PHI_DATA_ACCESS_WRITE',
  DTX_PHI_DATA_ACCESS_READ_ONLY = 'DTX_PHI_DATA_ACCESS_READ_ONLY',
  DTX_PHI_DATA_ACCESS_READ_NAMES_ONLY = 'DTX_PHI_DATA_ACCESS_READ_NAMES_ONLY',
}
